import { useSyncExternalStore } from 'react'
import { getSessionRevoked, subscribeSessionRevoked } from '../api/sessionRevokedStore'

/** The server's message while a revoked session is held, else `null`. */
export function useSessionRevoked(): string | null {
  return useSyncExternalStore(subscribeSessionRevoked, getSessionRevoked)
}
